module.exports = __webpack_public_path__ + "static/images/components/Pagination/PaginationList/PaginationRender/images/item_select.7e09c3c7.png";


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/PaginationList/PaginationRender/images/item_select.png
// module id = 2655
// module chunks = 11